import React from "react";
import { Link } from "react-router-dom";

import styles from "./ComplexOrderItem.module.scss";
import { ComplexOrderInterface } from "../../../common/types/interfaces";
import { complexOrderRoute } from "../../../common/utils/constants";
import {
  getComplexOrderStatusText,
  getComplexOrderStatusTextColor,
} from "../../../common/utils/functions/enumToText";
import { ComplexOrderStatus } from "../../../common/types/enums";

interface Props {
  order: ComplexOrderInterface;
  lastItemRef?: (node: HTMLAnchorElement | null) => void;
}

const formatDate = (iso: string) =>
  new Date(iso).toLocaleString("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

export const ComplexOrderItem: React.FC<Props> = ({ order, lastItemRef }) => {
  const cluster = order.cluster;
  const status = order.status as ComplexOrderStatus;

  return (
    <Link
      ref={lastItemRef}
      to={complexOrderRoute(order.id)}
      className={styles.Row}
    >
      <span className={styles.BgNumber} aria-hidden="true">
        #{order.id}
      </span>

      <div className={styles.RowInfo}>
        <div className={styles.TopLine}>
          {cluster && (
            <div className={styles.ClusterLine}>
              <img
                src={`https://${cluster.domain}/icons/logo512.png`}
                alt={cluster.name}
                className={styles.ClusterLogo}
              />
              <span className={styles.ClusterName}>{cluster.name}</span>
            </div>
          )}
        </div>

        <div className={styles.BottomLine}>
          <span
            className={styles.Status}
            style={{ color: getComplexOrderStatusTextColor(status) }}
          >
            {getComplexOrderStatusText(status)}
          </span>
          <span className={styles.Date}>{formatDate(order.createdAt)}</span>
          {order.total > 0 && (
            <span className={styles.Total}>{order.total} ₽</span>
          )}
        </div>
      </div>
    </Link>
  );
};